import { Handle, Position } from '@xyflow/react';
import {
  // CompetitorsCard, // Key Competitors card hidden on Nexus canvas
  GoogleAdsCard,
  LinkedinAdsCard,
  MetaAdsCard,
  NewsCard,
  ReadoutCard,
  SecCard,
  SerffCard,
} from './NexusCards';

const SOURCE_CARD_WIDTH = 340;
const READOUT_WIDTH = 400;
// const COMPETITORS_WIDTH = 320;

function SourceFlowNode({ children, sourcePosition }) {
  return (
    <div className="nexus-flow-node nexus-flow-node--source nopan">
      {children}
      <Handle
        type="source"
        id="out"
        position={sourcePosition}
        className="nexus-flow-handle nexus-flow-handle--source"
      />
    </div>
  );
}

function SerffFlowNode() {
  return (
    <SourceFlowNode sourcePosition={Position.Right}>
      <SerffCard />
    </SourceFlowNode>
  );
}

function SecFlowNode() {
  return (
    <SourceFlowNode sourcePosition={Position.Left}>
      <SecCard />
    </SourceFlowNode>
  );
}

function NewsFlowNode() {
  return (
    <SourceFlowNode sourcePosition={Position.Right}>
      <NewsCard />
    </SourceFlowNode>
  );
}

function LinkedinAdsFlowNode() {
  return (
    <SourceFlowNode sourcePosition={Position.Left}>
      <LinkedinAdsCard />
    </SourceFlowNode>
  );
}

function MetaAdsFlowNode() {
  return (
    <SourceFlowNode sourcePosition={Position.Left}>
      <MetaAdsCard />
    </SourceFlowNode>
  );
}

function GoogleAdsFlowNode() {
  return (
    <SourceFlowNode sourcePosition={Position.Left}>
      <GoogleAdsCard />
    </SourceFlowNode>
  );
}

/** @deprecated Legacy node type — maps to LinkedIn ads card */
function AdsFlowNode() {
  return <LinkedinAdsFlowNode />;
}

function ReadoutFlowNode() {
  return (
    <div className="nexus-flow-node nexus-flow-node--readout nopan">
      <Handle
        type="target"
        id="left"
        position={Position.Left}
        className="nexus-flow-handle nexus-flow-handle--target"
      />
      <Handle
        type="target"
        id="right"
        position={Position.Right}
        className="nexus-flow-handle nexus-flow-handle--target"
      />
      <Handle
        type="target"
        id="top"
        position={Position.Top}
        className="nexus-flow-handle nexus-flow-handle--target nexus-flow-handle--readout-top"
      />
      <Handle
        type="target"
        id="bottom"
        position={Position.Bottom}
        className="nexus-flow-handle nexus-flow-handle--target nexus-flow-handle--readout-bottom"
      />
      <ReadoutCard />
    </div>
  );
}

// function CompetitorsFlowNode() {
//   return (
//     <div className="nexus-flow-node nexus-flow-node--competitors nopan">
//       <CompetitorsCard />
//     </div>
//   );
// }

export const nexusNodeTypes = {
  serff: SerffFlowNode,
  sec: SecFlowNode,
  news: NewsFlowNode,
  linkedinAds: LinkedinAdsFlowNode,
  metaAds: MetaAdsFlowNode,
  googleAds: GoogleAdsFlowNode,
  ads: AdsFlowNode,
  readout: ReadoutFlowNode,
  // competitors: CompetitorsFlowNode,
};

/** Fixed layout — positions tuned for ~1180×760 viewport */
export const nexusInitialNodes = [
  {
    id: 'serff',
    type: 'serff',
    position: { x: 24, y: 32 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: SOURCE_CARD_WIDTH },
  },
  {
    id: 'sec',
    type: 'sec',
    position: { x: 816, y: 32 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: SOURCE_CARD_WIDTH },
  },
  {
    id: 'readout',
    type: 'readout',
    position: { x: 390, y: 200 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: READOUT_WIDTH },
  },
  {
    id: 'news',
    type: 'news',
    position: { x: 24, y: 400 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: SOURCE_CARD_WIDTH },
  },
  {
    id: 'linkedinAds',
    type: 'linkedinAds',
    position: { x: 780, y: 280 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: SOURCE_CARD_WIDTH },
  },
  {
    id: 'metaAds',
    type: 'metaAds',
    position: { x: 780, y: 600 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: SOURCE_CARD_WIDTH },
  },
  {
    id: 'googleAds',
    type: 'googleAds',
    position: { x: 780, y: 440 },
    data: {},
    draggable: true,
    selectable: true,
    style: { width: SOURCE_CARD_WIDTH },
  },
  // Key Competitors card — hidden until product re-enables
  // {
  //   id: 'competitors',
  //   type: 'competitors',
  //   position: { x: 400, y: 720 },
  //   data: {},
  //   draggable: true,
  //   selectable: true,
  //   style: { width: COMPETITORS_WIDTH },
  // },
];

export const nexusInitialEdges = [
  {
    id: 'serff-readout',
    source: 'serff',
    target: 'readout',
    sourceHandle: 'out',
    targetHandle: 'left',
    type: 'smoothstep',
  },
  {
    id: 'sec-readout',
    source: 'sec',
    target: 'readout',
    sourceHandle: 'out',
    targetHandle: 'right',
    type: 'smoothstep',
  },
  {
    id: 'news-readout',
    source: 'news',
    target: 'readout',
    sourceHandle: 'out',
    targetHandle: 'left',
    type: 'smoothstep',
  },
  {
    id: 'linkedin-readout',
    source: 'linkedinAds',
    target: 'readout',
    sourceHandle: 'out',
    targetHandle: 'right',
    type: 'smoothstep',
  },
  {
    id: 'meta-readout',
    source: 'metaAds',
    target: 'readout',
    sourceHandle: 'out',
    targetHandle: 'right',
    type: 'smoothstep',
  },
  {
    id: 'google-readout',
    source: 'googleAds',
    target: 'readout',
    sourceHandle: 'out',
    targetHandle: 'right',
    type: 'smoothstep',
  },
];

export const nexusDefaultEdgeOptions = {
  type: 'smoothstep',
  style: { strokeWidth: 2 },
  pathOptions: { borderRadius: 16 },
};
